export const getArrayDifference = (a1: number[], a2: number[]): number[] => {
  return a1
    .filter(x => !a2.includes(x))
    .concat(a2.filter(x => !a1.includes(x)))
}
